import { put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { TripInformationConstants } from '../store/tripInformation.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { ITripInformationState } from '../store/tripInformation.types'
import { getTripInformationSelector } from '../selectors'
import { getTripInformationOptionsSelector } from '../../options/selectors/tripInformationOptions.selector'
import { ITripInformationOptionsState } from '../../options/store/options.types'
import { setUnit } from '../store/tripInformation.actions'
import { optionwWithStateIds } from '../utils/tripInformation.util'
import { getTimesSelector } from '../../times/selectors'
import { setAtLandingDate, setAtLandingTime, setDescentDate, setDescentTime } from '../../times/store/times.actions'
import { ITimesState } from '../../times/store/times.types'
import { getServiceConfigSelector } from '../../configurations/selectors/serviceConfig.selector'
import { IServiceConfig } from '../../configurations/store/configurations.types'
import { IUnitOption } from '../../options/store/options.types'
import { showAtLanding, showDescent } from '../../times/utils/timesGrid.util'

export function* setTripInfoUnit() {
  const tripInformation: ITripInformationState = yield select(getTripInformationSelector)
  const tripInfoOptions: ITripInformationOptionsState = yield select(getTripInformationOptionsSelector)
  const { emsVehicleOptions } = tripInfoOptions
  const { __unitOption } = tripInformation
  try {
    const unitOption = optionwWithStateIds(__unitOption, emsVehicleOptions) as IUnitOption | null
    const times: ITimesState = yield select(getTimesSelector)
    const serviceConfig: IServiceConfig = yield select(getServiceConfigSelector)
    const isDescentSupported = showDescent(unitOption, serviceConfig.AIR)
    const isAtLandingSupported = showAtLanding(unitOption)

    yield put(setUnit(unitOption))
    if (!isDescentSupported && (times.descentDate || times.descentTime)) {
      yield put(setDescentDate(''))
      yield put(setDescentTime(''))
    }
    if (!isAtLandingSupported && (times.atLandingDate || times.atLandingTime)) {
      yield put(setAtLandingDate(''))
      yield put(setAtLandingTime(''))
    }
  } catch (e) {
    yield put(throwPcrException(`setTripInfoUnit() error: ${e}`))
  }
}

export function* setTripInfoUnitSaga() {
  yield takeLatest([TripInformationConstants.SET_UNIT_OPTION], performWithMutexHOG, setTripInfoUnit)
}
